function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { actionSearchTypesName, actionSearchTypesColorMap, dateTimeFormat, ACTION_STATUS, actionStatusName, actionStatusColorMap, actionEventTypeName, actionEventTypeColorMap } from 'enums';
import { Row, Col, Paper, BackButton, Button, ColorBatch, ActionForm, DateTimePicker } from 'components';
import { showApiError } from 'utils';
import { showSuccess } from 'components/UI';
import { getAction, completeAction, snoozeAction, getActionEventLog } from 'services';
import { list, headerLeftTitle } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var snoozeBarStyle = function snoozeBarStyle(theme) {
  return {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '1.2em',
    padding: '1.2em 2em',
    marginBottom: '1.5em',
    backgroundColor: theme.warningLight,
    border: "1px solid ".concat(theme.warning),
    '& .snooze-icon': {
      fontSize: '2rem',
      color: theme.warning,
      flexShrink: 0,
      marginBottom: '0.4em'
    },
    '& .snooze-picker': {
      flex: '0 0 200px',
      '& > div': {
        marginBottom: 0
      }
    },
    '& .snooze-actions': {
      display: 'flex',
      gap: '0.6em',
      flexShrink: 0,
      paddingBottom: '1px'
    }
  };
};

var ActionDetails = function ActionDetails(_ref) {
  var _location$state, _match$params, _actionData$employee$, _actionData$employee, _actionData$borrower, _actionData$borrower2, _actionData$borrower3, _actionData$borrower4, _actionData$borrower5, _actionData$credit, _actionData$credit2;

  var location = _ref.location,
      match = _ref.match,
      history = _ref.history;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      action = _ref2.action;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      actionId = _ref3.actionId;

  var _useState = useState(action),
      _useState2 = _slicedToArray(_useState, 2),
      actionData = _useState2[0],
      setActionData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEdit = _useState4[0],
      setIsEdit = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      eventLog = _useState6[0],
      setEventLog = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showSnooze = _useState8[0],
      setShowSnooze = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      snoozeDate = _useState10[0],
      setSnoozeDate = _useState10[1];

  useEffect(function () {
    fetchAction();
    fetchEventLog();
  }, []);

  var fetchAction = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAction, _yield$getAction2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAction(actionId);

            case 2:
              _yield$getAction = _context.sent;
              _yield$getAction2 = _slicedToArray(_yield$getAction, 2);
              res = _yield$getAction2[0];
              err = _yield$getAction2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setActionData(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAction() {
      return _ref4.apply(this, arguments);
    };
  }();

  var fetchEventLog = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$getActionEvent, _yield$getActionEvent2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getActionEventLog(actionId);

            case 2:
              _yield$getActionEvent = _context2.sent;
              _yield$getActionEvent2 = _slicedToArray(_yield$getActionEvent, 2);
              res = _yield$getActionEvent2[0];
              err = _yield$getActionEvent2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return");

            case 8:
              setEventLog(res || []);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchEventLog() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleUpdate = function handleUpdate(data) {
    setActionData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), data);
    });
    setIsEdit(false);
    fetchEventLog();
  };

  var handleClose = function handleClose() {
    return setIsEdit(false);
  };

  var handleComplete = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$completeAction, _yield$completeAction2, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return completeAction(actionId);

            case 2:
              _yield$completeAction = _context3.sent;
              _yield$completeAction2 = _slicedToArray(_yield$completeAction, 2);
              err = _yield$completeAction2[1];

              if (!err) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 7:
              showSuccess('Действието е маркирано като завършено.');
              fetchAction();
              fetchEventLog();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleComplete() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleSnoozeOpen = function handleSnoozeOpen() {
    setShowSnooze(true);
    setSnoozeDate(null);
  };

  var handleSnoozeConfirm = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var formatted, _yield$snoozeAction, _yield$snoozeAction2, err;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (snoozeDate) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              formatted = moment.isMoment(snoozeDate) ? snoozeDate.format('YYYY-MM-DD') : snoozeDate;
              _context4.next = 5;
              return snoozeAction(actionId, formatted);

            case 5:
              _yield$snoozeAction = _context4.sent;
              _yield$snoozeAction2 = _slicedToArray(_yield$snoozeAction, 2);
              err = _yield$snoozeAction2[1];

              if (!err) {
                _context4.next = 10;
                break;
              }

              return _context4.abrupt("return", showApiError(err));

            case 10:
              showSuccess('Действието е отложено.');
              setShowSnooze(false);
              setSnoozeDate(null);
              fetchAction();
              fetchEventLog();

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSnoozeConfirm() {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleSnoozeCancel = function handleSnoozeCancel() {
    setShowSnooze(false);
    setSnoozeDate(null);
  };

  var currentStatus = (actionData === null || actionData === void 0 ? void 0 : actionData.status) || ACTION_STATUS.active;
  var isActive = currentStatus === ACTION_STATUS.active;
  var isSnoozed = currentStatus === ACTION_STATUS.snoozed;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "2em",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.push('/actions');
    }
  }), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "ID: ", actionData === null || actionData === void 0 ? void 0 : actionData.id))), ___EmotionJSX(Row, {
    backgroundColor: "white",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref8) {
      var css = _ref8.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u0442\u043E"), ___EmotionJSX("div", {
        style: {
          display: 'flex',
          gap: '0.5em'
        }
      }, (isActive || isSnoozed) && ___EmotionJSX(Button, {
        small: true,
        type: "primary",
        onClick: handleComplete,
        leftIcon: {
          iconName: 'la la-check',
          size: 18
        }
      }, "\u0417\u0430\u0432\u044A\u0440\u0448\u0438"), isActive && ___EmotionJSX(Button, {
        small: true,
        color: "white",
        backColor: "#D97706",
        hoverBackColor: "#B45309",
        onClick: handleSnoozeOpen,
        leftIcon: {
          iconName: 'la la-clock',
          size: 18
        }
      }, "\u041E\u0442\u043B\u043E\u0436\u0438"), !isEdit && ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return setIsEdit(function (prev) {
            return !prev;
          });
        },
        leftIcon: {
          iconName: 'la la-pen',
          size: 18
        }
      }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439")));
    },
    margin: "0 0 2em 0"
  }, showSnooze && ___EmotionJSX("div", {
    css: snoozeBarStyle
  }, ___EmotionJSX("i", {
    className: "las la-clock snooze-icon"
  }), ___EmotionJSX("div", {
    className: "snooze-picker"
  }, ___EmotionJSX(DateTimePicker, {
    small: true,
    label: "\u041E\u0442\u043B\u043E\u0436\u0438 \u0434\u043E",
    value: snoozeDate,
    onChange: setSnoozeDate,
    timeFormat: false,
    dateFormat: "YYYY-MM-DD"
  })), ___EmotionJSX("div", {
    className: "snooze-actions"
  }, ___EmotionJSX(Button, {
    small: true,
    color: "white",
    backColor: "#D97706",
    hoverBackColor: "#B45309",
    onClick: handleSnoozeConfirm
  }, "\u041E\u0442\u043B\u043E\u0436\u0438"), ___EmotionJSX(Button, {
    small: true,
    type: "secondary",
    onClick: handleSnoozeCancel
  }, "\u041E\u0442\u043A\u0430\u0437"))), isEdit ? ___EmotionJSX(ActionForm, {
    data: actionData,
    onSubmit: handleUpdate,
    onClose: handleClose,
    creditId: actionData === null || actionData === void 0 ? void 0 : actionData.credit_id,
    borrowerId: actionData === null || actionData === void 0 ? void 0 : actionData.borrower_id
  }) : ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u0442\u0430\u0442\u0443\u0441"), ___EmotionJSX("p", {
    className: "value"
  }, ___EmotionJSX(ColorBatch, {
    type: actionStatusColorMap[currentStatus]
  }, actionStatusName[currentStatus]))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u044A\u0437\u0434\u0430\u0434\u0435\u043D \u043D\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, moment(actionData === null || actionData === void 0 ? void 0 : actionData.created_at).isValid() ? moment(actionData === null || actionData === void 0 ? void 0 : actionData.created_at).format(dateTimeFormat) : 'N/A')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, ___EmotionJSX(ColorBatch, {
    type: actionSearchTypesColorMap[actionData === null || actionData === void 0 ? void 0 : actionData.action]
  }, actionSearchTypesName[actionData === null || actionData === void 0 ? void 0 : actionData.action]))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, actionData !== null && actionData !== void 0 && actionData.follow_up_date ? moment(actionData.follow_up_date).format('DD-MM-YYYY') : '—')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B"), ___EmotionJSX("p", {
    className: "value"
  }, (_actionData$employee$ = actionData === null || actionData === void 0 ? void 0 : (_actionData$employee = actionData.employee) === null || _actionData$employee === void 0 ? void 0 : _actionData$employee.name) !== null && _actionData$employee$ !== void 0 ? _actionData$employee$ : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0414\u0435\u0442\u0430\u0439\u043B\u0438"), ___EmotionJSX("p", {
    className: "value"
  }, actionData !== null && actionData !== void 0 && actionData.borrower ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Link, {
    to: "borrowers/details/".concat(actionData === null || actionData === void 0 ? void 0 : (_actionData$borrower = actionData.borrower) === null || _actionData$borrower === void 0 ? void 0 : _actionData$borrower.id_number)
  }, actionData === null || actionData === void 0 ? void 0 : (_actionData$borrower2 = actionData.borrower) === null || _actionData$borrower2 === void 0 ? void 0 : _actionData$borrower2.first_name, " ", actionData === null || actionData === void 0 ? void 0 : (_actionData$borrower3 = actionData.borrower) === null || _actionData$borrower3 === void 0 ? void 0 : _actionData$borrower3.middle_name, ' ', actionData === null || actionData === void 0 ? void 0 : (_actionData$borrower4 = actionData.borrower) === null || _actionData$borrower4 === void 0 ? void 0 : _actionData$borrower4.last_name), ___EmotionJSX("p", null, actionData === null || actionData === void 0 ? void 0 : (_actionData$borrower5 = actionData.borrower) === null || _actionData$borrower5 === void 0 ? void 0 : _actionData$borrower5.id_number)) : ___EmotionJSX(React.Fragment, null, "\u041A\u0440\u0435\u0434\u0438\u0442 \u2116:", ___EmotionJSX("br", null), ___EmotionJSX(Link, {
    to: "credits/details/".concat(actionData === null || actionData === void 0 ? void 0 : (_actionData$credit = actionData.credit) === null || _actionData$credit === void 0 ? void 0 : _actionData$credit.id)
  }, actionData === null || actionData === void 0 ? void 0 : (_actionData$credit2 = actionData.credit) === null || _actionData$credit2 === void 0 ? void 0 : _actionData$credit2.number)))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, ___EmotionJSX("strong", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"), ___EmotionJSX("br", null), " ", actionData === null || actionData === void 0 ? void 0 : actionData.note)))))), ___EmotionJSX(Row, {
    backgroundColor: "white",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref9) {
      var css = _ref9.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0414\u043D\u0435\u0432\u043D\u0438\u043A \u043D\u0430 \u0441\u044A\u0431\u0438\u0442\u0438\u044F\u0442\u0430"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX("div", {
    css: list
  }, eventLog.length > 0 ? ___EmotionJSX("table", {
    className: "list-table"
  }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("th", null, "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B"), ___EmotionJSX("th", null, "\u0421\u044A\u0431\u0438\u0442\u0438\u0435"), ___EmotionJSX("th", null, "\u0414\u0435\u0442\u0430\u0439\u043B\u0438"))), ___EmotionJSX("tbody", null, eventLog.map(function (event) {
    var _event$user, _event$employee;

    return ___EmotionJSX("tr", {
      key: event === null || event === void 0 ? void 0 : event.id
    }, ___EmotionJSX("td", null, moment(event === null || event === void 0 ? void 0 : event.created_at).isValid() ? moment(event === null || event === void 0 ? void 0 : event.created_at).format(dateTimeFormat) : 'N/A'), ___EmotionJSX("td", null, (event === null || event === void 0 ? void 0 : (_event$user = event.user) === null || _event$user === void 0 ? void 0 : _event$user.name) || (event === null || event === void 0 ? void 0 : (_event$employee = event.employee) === null || _event$employee === void 0 ? void 0 : _event$employee.name) || '—'), ___EmotionJSX("td", null, ___EmotionJSX(ColorBatch, {
      type: actionEventTypeColorMap[event === null || event === void 0 ? void 0 : event.event_type],
      fontSize: "1rem"
    }, actionEventTypeName[event === null || event === void 0 ? void 0 : event.event_type] || (event === null || event === void 0 ? void 0 : event.event_type))), ___EmotionJSX("td", null, (event === null || event === void 0 ? void 0 : event.data) || '—'));
  }))) : ___EmotionJSX("p", {
    style: {
      padding: '1.2em 0.8em',
      color: '#999'
    }
  }, "\u041D\u044F\u043C\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F."))))));
};

ActionDetails.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};
export default ActionDetails;